import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeadphones: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconHeadphones"><Path d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12V13H18.5C17.1193 13 16 14.1193 16 15.5V18.5C16 19.8807 17.1193 21 18.5 21C19.8807 21 21 19.8807 21 18.5V12C21 7.19722 17.238 3.2731 12.5 3.01365V3H12C7.02944 3 3 7.02944 3 12V18.5C3 19.8807 4.11929 21 5.5 21C6.88071 21 8 19.8807 8 18.5V15.5C8 14.1193 6.88071 13 5.5 13H4V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHeadphones;
